import TournamentCreate from './tournament.create';

export default {
  create: TournamentCreate,
};
